import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=c2654e8a&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=c2654e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2654e8a",
  null
  
)

export default component.exports